import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

// 📄 Interface d’un fichier lié à un document
export interface DocumentFile {
  fileName: string;
  path: string;
}

// 📄 Interface principale d’un document
export interface Document {
  id: number;
  name: string;
  description: string;
  vu: string;
  creationDate: string;
  nbrDocuments: number;
  totalPage?: number;
  files: DocumentFile[];
}

// 📦 Interface de la réponse API
export interface DocumentResponse {
  error: string;
  response: Document[];
}

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  private readonly apiBaseUrl = environment.apiUrl.replace(/\/$/, '');
  private readonly apiOrigin = this.apiBaseUrl.replace(/\/api$/, '');
  private readonly baseUrl =
    `${this.apiBaseUrl}/archiveExamens/listArchiveexamens`;

  constructor(private http: HttpClient) {}

  /**
   * 📚 Récupère la liste des documents d’un élève depuis l’API
   */
  getStudentDocuments(
    nameOrg: string,
    idRole: number,
    idGrade: number,
    idBatch: number,
    idStudent: number,
    idUser: number,
    numberPage: number = 1,
    sizePage: number = 100
  ): Observable<Document[]> {
    const body = {
      nameOrg,
      idRole,
      idGrade,
      idBatch,
      idStudent,
      idUser,
      numberPage,
      sizePage,
    };

    return this.http.post<DocumentResponse>(this.baseUrl, body).pipe(
      map((res) => {
        if (res && Array.isArray(res.response)) {
          // ✅ Nettoyage des chemins de fichiers
          return res.response.map((doc) => ({
            ...doc,
            totalPage: (doc as any).totalPage,
            files: (doc.files || []).map((f) => ({
              fileName: f.fileName,
              path: this.buildAbsoluteUrl(f.path),
            })),
          }));
        }

        console.warn('⚠️ Réponse inattendue de l’API:', res);
        return [];
      })
    );
  }

  /**
   * 🌐 Construit une URL absolue si nécessaire
   */
  private buildAbsoluteUrl(path: string): string {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    return `${this.apiOrigin}${path}`;
  }
}
